var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrdersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "{className} ",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 97 88.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.3,2.5c-0.2-1.4-1.5-2.5-3-2.5H3C1.3,0,0,1.3,0,3s1.3,3,3,3h10.8l6.9,41.7c0,0.2,0,0.4,0.1,0.7l2.4,14.3   c0.2,1.4,1.5,2.5,3,2.5H83c1.7,0,3-1.3,3-3s-1.3-3-3-3H28.7l-1.4-8.7H85c1.4,0,2.6-0.9,2.9-2.2l9-34.2c0.2-0.9,0-1.9-0.5-2.6   c-0.6-0.7-1.4-1.2-2.4-1.2H20.6L19.3,2.5z M90.1,16.3l-7.5,28.2H26.3l-4.7-28.2H90.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45,78.4c0-5.7-4.6-10.3-10.3-10.3s-10.2,4.6-10.2,10.3s4.6,10.3,10.3,10.3S45,84,45,78.4z M30.5,78.4   c0-2.3,1.9-4.3,4.3-4.3s4.3,1.9,4.3,4.3s-1.9,4.3-4.3,4.3S30.5,80.7,30.5,78.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.3,78.4c0-5.7-4.6-10.3-10.3-10.3c-5.7,0-10.3,4.6-10.3,10.3c0,5.7,4.6,10.3,10.3,10.3   C74.7,88.6,79.3,84,79.3,78.4z M64.8,78.4c0-2.3,1.9-4.3,4.3-4.3s4.3,1.9,4.3,4.3s-1.9,4.3-4.3,4.3S64.8,80.7,64.8,78.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersIcon);
export default __webpack_public_path__ + "static/media/orders_icon.35b4731f8ee6b80f426947660a473664.svg";
export { ForwardRef as ReactComponent };